<template>
    <div class="container">
        <div class="main-block">
            <div class="store-block" v-if="isLogin">

                <!--活動卡-->
                <Gift isWeb :isTypeWeb="'oinCard'"/>

            </div>
        </div>

        <!--判斷有無登入-->
        <LoginWeb/>

    </div>
</template>

<script>
    import Gift from "@/views/gift/Index";
    import LoginWeb from "./components/LoginWeb";

    export default {
        name: "WebStoreOinCard",
        components: {
            Gift,
            LoginWeb,
        },
        data() {
            return {
                isLogin: this.$auth.isAdminLogin(),
            }
        },
        created() {

        },
        mounted() {

        },
        methods: {

        },
    }
</script>
